<template>
  <div class="app">
    <div v-html='content' class="content">
      <!-- {{content}} -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'privacyAgreement',
  data () {
    return {
      content: ''
    }
  },
  mounted() {
       this.getData();
  },
  methods: {
    getData() {
          this.$axios({
                method:'get',
                url:'/api/agreement/agreement',
                params:{
                   type:2
                }
            }).then((response) =>{          
                //请求成功返回的数据
                this.content= response.data.data
            }).catch((error) =>
                console.log(error) //请求失败返回的数据
            )

   }
 }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.content{
  padding: 10px 15px;
  line-height:2em;
  width: 92%;
  overflow: hidden;
  word-wrap:break-word; 
  word-break:normal;
}
</style>



// WEBPACK FOOTER //
// src/components/privacyAgreement.vue